export default __webpack_public_path__ + "assets/images/entrega-successd0c91cb5667dfdbfb042c00a753899c4.png";